module.exports = __webpack_public_path__ + "static/media/Meditite_gaussian2.b12cf3d0.png";